// Loader copy + timing knobs for <TurboLoader>. Lives separately so
// the copy can be edited without touching the component code. Strings
// are stored without trailing ellipsis - the component appends three
// pulsing dots in centred layouts, a static "..." in the inline one.

export const LOADER_ROTATING_COPY = [
  'Hold tight',
  "Turbo's on it",
  'Just a sec',
  'Warming up the engines',
  'Almost there',
  'Loading the good stuff',
];

// Shown after LOADER_REASSURANCE_DELAY_MS so users on a slow request
// see the message change instead of staring at the same line forever.
// Skipped when the parent passes a custom `message` prop - their copy
// is deliberate and shouldn't be overridden.
export const LOADER_REASSURANCE_COPY = 'Still working on it';

// Mount delay: under 2 seconds the loader never appears, the load
// finishes before the user notices. If the parent unmounts the
// loader before this fires, nothing ever renders.
export const LOADER_MOUNT_DELAY_MS = 2000;

// Time from mount until the rotating copy swaps to the reassurance
// line. Measured from mount, not from "visible" - the parent
// experiences ~6 seconds of the rotating line + the reassurance
// after that point.
export const LOADER_REASSURANCE_DELAY_MS = 8000;

// Empty-state copy for the dashboard At Risk / Briefs Due This Week
// panels. Celebratory rather than apologetic - "nothing here" is
// reframed as "opportunity / on top of things" so an empty panel
// rewards the user rather than reading as a gap. Stored here (not
// inlined in Dashboard.js) so the copy can be tuned without touching
// component code.
export const DASHBOARD_EMPTY_COPY = {
  briefs_due_this_week: {
    primary: 'Nothing due in the next 7 days.',
    sub: 'A quiet week ahead — good time to plan the next batch.',
  },
  at_risk: {
    primary: 'Nothing at risk right now. Nice.',
    sub: "Briefs you've sent are all on track. Keep it up.",
  },
};
